/** Public signup funnels where third-party widgets hurt LCP/TBT. */
export const isSignupRoute = (path = '') => {
  const normalized = path.split('?')[0]
  return normalized === '/signup' || normalized.startsWith('/signup/')
}
